<template>
    <span class="rank">
        <img class="rank-icon"
            :src="getAssetUrl(`../../assets/badge_${rank}.png`)"
            :title="rankToLabel(rank)"
            :class="{['animated zoom-in']: animate}"
        />
    </span>
</template>

<script>
import { getAssetUrl } from '../../helpers/assets';

export default {
    props: ['skillRating'],
    name: 'Rank',
    data() {
        return {
            animate: false,
        };
    },
    watch: {
        skillRating(current, prev) {
            if (current > prev &&
                this.skillRatingToRank(current) !==
                this.skillRatingToRank(prev)) {
                this.animate = true;
            }
        },
    },
    computed: {
        rank() {
            return this.skillRatingToRank(this.skillRating);
        },
    },
    methods: {
        getAssetUrl,
        skillRatingToRank(skillRating) {
            let rank = 'gold';

            if (skillRating >= 0 && skillRating <= 1499) {
                rank = 'bronze';
            } else if (skillRating >= 1500 && skillRating <= 1999) {
                rank = 'silver';
            } else if (skillRating >= 2000 && skillRating <= 2499) {
                rank = 'gold';
            } else if (skillRating >= 2500 && skillRating <= 2999) {
                rank = 'platinum';
            } else if (skillRating >= 3000 && skillRating <= 3499) {
                rank = 'diamond';
            } else if (skillRating >= 3500 && skillRating <= 3999) {
                rank = 'masters';
            } else if (skillRating >= 4000) {
                rank = 'grandmaster';
            }

            return rank;
        },
        rankToLabel(text) {
            return `${text.slice(0, 1).toUpperCase()}${text.slice(1).toLowerCase()}`;
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .rank {
        vertical-align: middle;

        .rank-icon {
            height: auto;
            max-height: 14px;
            max-width: 17px;
            width: auto;
        }
    }

    .waiting-room {

        .rank {

            .rank-icon {
                max-width: 16px;
            }
        }
    }

    .leaderboard {

        .rank {
            vertical-align: baseline;
        }
    }

    .modal {

        &.victory {

            .rank {

                .rank-icon {
                    max-height: 17px;
                    max-width: 20px;
                }
            }
        }
    }

    .users-container {

        .rank-icon {
            margin-left: 4px;
            vertical-align: middle;
        }
    }

</style>
